<template>
    <button
        class="l-ss-c-button"
        :class="{ 'l-ss-c-button-loading': loading }"
        :disabled="loading || disabled"
        @click="$emit('click', $event)">
        <transition
            name="scale-down"
            mode="out-in">
            <slot v-if="!loading"></slot>
            <pulse-dots v-else/>
        </transition>
    </button>
</template>

<script>
    import PulseDots from '@/core/components/pulse-dots.vue';

    export default {
        components: { PulseDots },
        props: {
            loading: {
                type: Boolean,
                default: false,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>

<style scoped>

</style>